import { render, staticRenderFns } from "./currentUserAccessStore.vue?vue&type=template&id=10c9b4f6"
import script from "./currentUserAccessStore.vue?vue&type=script&lang=js"
export * from "./currentUserAccessStore.vue?vue&type=script&lang=js"
import style0 from "./currentUserAccessStore.vue?vue&type=style&index=0&id=10c9b4f6&prod&lang=less"
import style1 from "./currentUserAccessStore.vue?vue&type=style&index=1&id=10c9b4f6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports